import { flexDirection, flexWrap, alignItems, justifyContent, compose } from "styled-system";
import styled from "@sonos-inc/web-ui-styled";
import css from "@sonos-inc/web-ui-css";
import { BlockStyles } from "@sonos-inc/web-ui-block";
export var FlexStyles = [compose(BlockStyles, flexDirection, flexWrap, alignItems, justifyContent), css({
  display: "flex"
})];
/**
 * Flex is a container that renders its contents in one direction. A Flex container can either be a **Row** or **Column**.
 *
 * Read [here](https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Flexible_Box_Layout/Basic_Concepts_of_Flexbox) to learn about Flexbox principles.
 */

export var Flex = styled.div(FlexStyles);
Flex.defaultProps = {
  flexDirection: "row"
};
Flex.displayName = "Flex";
export default Flex;